
import { get, post } from '../client';

export interface WhatsappStatus {
  status: 'DISCONNECTED' | 'CONNECTING' | 'CONNECTED' | 'QR_READY';
  qr: string | null;
}

export async function getWhatsappStatus(): Promise<WhatsappStatus> {
  return await get<WhatsappStatus>('/admin/whatsapps/status');
}

export async function logoutWhatsapp(): Promise<{ message: string }> {
  return await post<{ message: string }>('/admin/whatsapps/logout', {});
}

export async function resetWhatsapp(): Promise<{ message: string }> {
  return await post<{ message: string }>('/admin/whatsapps/reset', {});
}
